import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { bindPopover, usePopupState } from 'material-ui-popup-state/hooks';

import { MessagingCampaignsFilterSchema } from './messaging-campaigns-filter.schema';
import { messagingCampaignsFilterToGqlFilter } from './messaging-campaigns-filter.utils';
import { MessagingCampaignsFilterFormValues } from './messaging-campaigns-filter.types';

export const useMessagingCampaignsFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const filterFormValues = useMemo(() => {
    const input: Record<string, unknown> = Object.fromEntries(searchParams.entries());
    const filter = MessagingCampaignsFilterSchema.safeParse(input);
    if (filter.success) return filter.data;
    // TODO: handle invalid filter in a better way
    console.warn('Invalid filter from search params', filter.error.format());
    return {};
  }, [searchParams]);

  const queryFilter = useMemo(() => {
    return messagingCampaignsFilterToGqlFilter(filterFormValues);
  }, [filterFormValues]);

  const popupState = usePopupState({ variant: 'popover', popupId: 'messaging-campaigns-filters' });
  const popoverProps = useMemo(() => {
    return {
      ...bindPopover({
        ...popupState,
      }),
    };
  }, [popupState]);

  return {
    queryFilter,
    isActive: Object.keys(filterFormValues).length > 0,
    value: filterFormValues,
    onChange: (nextFilters: MessagingCampaignsFilterFormValues) => {
      setSearchParams(nextFilters);
      popupState.close();
    },
    popoverProps,
    popupState,
  };
};
